import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPeerGroupsFilters } from "../../services/JobPricingReportService";

export interface PeerGroupsState {
  peerGroups: any;
  isPeerGroupsLoading: boolean;
  peerGroupsError: string | null;
}

const initialState: PeerGroupsState = {
  peerGroups: [],
  isPeerGroupsLoading: false,
  peerGroupsError: null
};

export const getPeerGroupsFiltersThunk = createAsyncThunk(
  "jobPricing/peerGroupsFilters",
  async (payload: any, thunkApi) => {
    try {
      const peergroupsthunkdata = await getPeerGroupsFilters(payload);
      return peergroupsthunkdata;
    } catch (error) {
      return thunkApi.rejectWithValue({ error });
    }
  }
);

const peerGroupsSlice = createSlice({
  name: "peerGroups",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPeerGroupsFiltersThunk.pending, (state) => {
      state.isPeerGroupsLoading = true;
      state.peerGroupsError = null;
    });
    builder.addCase(getPeerGroupsFiltersThunk.fulfilled, (state, action) => {
      state.isPeerGroupsLoading = false;
      state.peerGroups = action.payload;
    });
    builder.addCase(getPeerGroupsFiltersThunk.rejected, (state, action) => {
      state.isPeerGroupsLoading = false;
    });
  }
});

export default peerGroupsSlice.reducer;
